import React from 'react'
import { useTheme } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import CheckIcon from '@mui/icons-material/Check'
import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import WatchLaterIcon from '@mui/icons-material/WatchLater'
import GppMaybeIcon from '@mui/icons-material/GppMaybe'
import NewReleasesIcon from '@mui/icons-material/NewReleases'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import BlockIcon from '@mui/icons-material/Block'
import { getMessageStatus } from '../../libs/messageStatus'

// O ícone sozinho obrigava a passar o mouse em cada linha pra saber o que
// aconteceu. O rótulo por extenso resolve isso e, de quebra, tira a cor do papel
// de único portador da informação — quem não distingue vermelho de verde lê.
const ICONE_POR_ROTULO = {
  'Lida': DoneAllIcon,
  'Entregue': DoneAllIcon,
  'No servidor': CheckIcon,
  'Enviada': CheckIcon,
  'Falhou': ReportProblemIcon,
  'Em fila': WatchLaterIcon,
  'Adiada': WatchLaterIcon,
  'Saldo insuficiente': AccountBalanceWalletIcon,
  'Não quis receber': GppMaybeIcon,
  'Cancelada pelo cliente': BlockIcon,
  'Não identificado': NewReleasesIcon,
}

const DICA_POR_ROTULO = {
  'Lida': 'O destinatário abriu a mensagem',
  'Entregue': 'Chegou ao aparelho do destinatário',
  'No servidor': 'Aceita pelo servidor, ainda não entregue no aparelho',
  'Enviada': 'Saiu daqui, sem confirmação ainda',
  'Falhou': 'Não foi entregue',
  'Em fila': 'Aguardando a vez de sair',
  'Adiada': 'Segurada pelo anti-ban; volta sozinha',
  'Saldo insuficiente': 'Retida: a linha de crédito está sem saldo. Sai sozinha após a recarga',
  'Não quis receber': 'Destinatário pediu para não receber mais mensagens',
  'Cancelada pelo cliente': 'O disparo foi cancelado antes de ela sair; não foi enviada nem cobrada',
  'Não identificado': 'Estado não reconhecido',
}

export function coresDoTom(tom, theme) {
  if (tom === 'ok') return { fundo: theme.isDark ? '#123a2c' : '#e4f4ee', texto: theme.isDark ? '#3ddba4' : '#12805c' }
  if (tom === 'erro') return { fundo: theme.isDark ? '#3a1b1b' : '#fdeaea', texto: theme.isDark ? '#ef5350' : '#c62828' }
  if (tom === 'espera') return { fundo: theme.isDark ? '#3a2c15' : '#fdf1de', texto: theme.isDark ? '#f0a836' : '#b26a00' }
  if (tom === 'mudo') return { fundo: theme.isDark ? '#232d37' : '#eceff2', texto: theme.isDark ? '#9aa6b2' : '#54606c' }
  return { fundo: theme.isDark ? '#232d37' : '#eceff2', texto: theme.isDark ? '#aab6c2' : '#4a5661' }
}

export function corDaSeveridade(severidade, theme) {
  if (severidade === 'erro') return theme.isDark ? '#ef5350' : '#c62828'
  if (severidade === 'espera') return theme.isDark ? '#f0a836' : '#b26a00'
  if (severidade === 'mudo') return theme.isDark ? '#9aa6b2' : '#54606c'
  return 'transparent'
}

export default function MessageStatusChip({ message }) {
  const theme = useTheme()
  const estado = getMessageStatus(message)
  const Icone = ICONE_POR_ROTULO[estado.rotulo] || NewReleasesIcon
  const cores = coresDoTom(estado.tom, theme)

  return (
    <Tooltip title={DICA_POR_ROTULO[estado.rotulo] || ''}>
      <span
        className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold whitespace-nowrap"
        style={{ backgroundColor: cores.fundo, color: cores.texto }}
      >
        <Icone style={{ fontSize: 14 }} />
        {estado.rotulo}
      </span>
    </Tooltip>
  )
}
